import { type Car } from '@prisma/client'
import { useCallback, useEffect, useRef, useState } from 'react'
import OrderDetails from './orderDetails'

type Props = {
  car: Car[]
  financingAvailable: boolean
}

export default function DetailsRight({ car, financingAvailable }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isSticky, setIsSticky] = useState(false)

  const handleScroll = useCallback(() => {
    if (!containerRef.current) return
    const rect = containerRef.current.getBoundingClientRect()
    setIsSticky(rect.top <= 100)
  }, [])

  useEffect(() => {
    const onScroll = () => {
      requestAnimationFrame(handleScroll)
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [handleScroll])

  return (
    <div
      className={`
        mt-[56px] hidden flex-shrink flex-grow-0

        ${isSticky ? 'sticky top-[100px]' : ''}

        xl:inline-flex xl:min-w-0 xl:max-w-[428px] xl:basis-[428px]
      `}
      ref={containerRef}
    >
      <OrderDetails car={car as any} financingAvailable={financingAvailable} />
    </div>
  )
}
